import type { MutableRefObject } from 'react'
import { useEffect, useRef } from 'react'

function useIsMounted(): MutableRefObject<boolean> {
  const isMounted = useRef(true)

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  return isMounted
}

export default useIsMounted
